// 折扣码输入框

class CartDiscount extends HTMLElement {
    #activeFetch = null;

    #createAbortController() {
        if (this.#activeFetch) {
            this.#activeFetch.abort();
        }
        const abortController = new AbortController();
        this.#activeFetch = abortController;
        return abortController;
    }
    constructor() {
        super();
        this.symbol = this.dataset.symbol || '$';
        this.input = this.querySelector('input[type="text"]');
        this.button = this.querySelector('button[type="submit"]');
        this.radios = this.querySelectorAll('input[type="radio"]');
        this.input.addEventListener('keyup', this.onInputChange.bind(this));
        this.input.addEventListener('input', this.onInputChange.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));  

        this.radios && this.radios.forEach((radio) => {
            radio.addEventListener('change', this.onRadiosChange.bind(this));
        });

        this.addEventListener("click", (event) => {
           if(event.target.localName == 'div' && event.target.className == "discount-del"){
                const code = event.target.dataset.code || '';
                if (code) {
                    this.deleteChange(code,event);
                }
           }
        });
    }
    connectedCallback() {
        this.checkDiscount();
        // 页面加载时先刷新一次
        this.refreshCartDiscounts();

        // 每隔 1.5 秒刷新一次
        // setInterval(this.refreshCartDiscounts(), 1500);
    }

    async refreshCartDiscounts() {
        
        await fetch(Theme.routes.cart_update_url+".js").then(res => res.json()).then(cart => {
            const codes = cart.discount_codes;
            if(codes.length > 0){
                codes.forEach(discount=>{
                   const discountCodeList = this.querySelector('.discount-code-list');
                    if(discount.applicable && discountCodeList){
                        if (discountCodeList && ![...discountCodeList.children].some(item => item.querySelector("span").textContent.trim() === discount.code)) {
                            const codeItem = document.createElement('div');
                            codeItem.className = 'code-item';
                            codeItem.innerHTML = `<span>${discount.code}</span><div class="discount-del" data-code="${discount.code}"></div>` ;
                            discountCodeList.appendChild(codeItem);
                        }
                    }    
                })

            }
            
        }).catch(err => console.error('刷新折扣失败:', err));
    }

    // 监测code是否能正常使用
    async checkDiscount(){
         // 获取存在的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        const abortController = this.#createAbortController();

        var  existingDiscounts =[];
        
        codeValue.forEach((code) => {
            existingDiscounts.push(code.querySelector("span").textContent.trim());
        });


        if(existingDiscounts.length == 0) return;

        const response = await fetch(Theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                discount: existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();
        codeValue.forEach((item) => {
            const code = item.querySelector("span").textContent.trim();
            const discount_code = data.discount_codes.find(discount => discount.code === code);
            if (discount_code && !discount_code.applicable) {
            item.remove();
            }
        });


    }
    showToast(type,message) {
        // 创建新的toast元素
        const toast = document.createElement('div')
        toast.classList.add('sale-public-toast')
        // 设置toast的内容
        toast.innerHTML = `<div><em class="${type}"></em>${message}</div>`;

        // 将toast添加到页面中
        document.body.appendChild(toast)

        // 在一段时间后移除toast
        setTimeout(function () {
            document.body.removeChild(toast)
        }, 3000)
    }
    onRadiosChange(event){
        const selectedRadio = event.target;
        if (selectedRadio.checked) {
            this.input.value = selectedRadio.dataset.code || '';
        } else {
            this.input.value = '';
            this.button.classList.remove('selected');
        }

        this.onInputChange();
        this.button.click();
        
    }
    onInputChange() {
        if (this.input.value.trim() !== '') {
            this.button.classList.add('selected');
        } else {
            this.button.classList.remove('selected');
        }
        // 更新按钮状态
        if(this.button.classList.contains('cancle')){
            this.button.classList.remove('cancle');
            this.button.textContent = 'Apply';
            const codeInfo = this.querySelector(".code-info");
            if (codeInfo) {
                codeInfo.textContent = '';
            }
        }
    }

    // 删除code
    async deleteChange(code,event){
       // 获取存在的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        const abortController = this.#createAbortController();

        var  existingDiscounts =[];
        
        codeValue.forEach((code) => {
            existingDiscounts.push(code.querySelector("span").textContent.trim());
        });
        const index = existingDiscounts.indexOf(code);
        existingDiscounts.splice(index, 1);

        const response = await fetch(Theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                // discount: [this.button.classList.contains('cancle') ? '' : discountCodeValue].join(','),
                discount: existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();

       if(data){
            this.showToast("success", "This is the best discount right now.");
            this.input.value = '';
            this.radios.forEach((radio) => { radio.checked = false;});
            this.button.classList.remove('selected');
       }
        // 更新购物车
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

       // 删除当前节点
       event.target.parentNode.remove();


    }

    // 点击按钮
    async onButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.button.disabled = true;
        this.button.classList.add('loading');
        event.preventDefault();

        const discountCodeValue = this.input.value;
        if (!discountCodeValue) {
            this.showToast('error', 'Please enter a discount code.');
            this.button.disabled = false;
            this.button.classList.remove('loading');
            this.button.classList.remove('selected');
            this.input.value = '';
            return;
        }

        if (discountCodeValue.toLowerCase().includes('giftcard')) {
            this.showToast('error', 'Please apply gift card at checkout.');
            this.button.disabled = false;
            this.button.classList.remove('loading');
            this.button.classList.remove('selected');
            this.input.value = '';
            return;
        }

        // 获取存在的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        const abortController = this.#createAbortController();

        var  existingDiscounts =[];
        
        codeValue.forEach((code) => {
            existingDiscounts.push(code.querySelector("span").textContent.trim());
        });

        existingDiscounts.push(discountCodeValue);

        // if(this.button.classList.contains('cancle')){
        //     const index = existingDiscounts.indexOf(discountCodeValue);

        //     existingDiscounts.splice(index, 1);
        // }else{
        //  // discount: [...existingDiscounts, discountCodeValue].join(','),
        //  existingDiscounts.push(discountCodeValue);
        // }


        const response = await fetch(Theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                // discount: [this.button.classList.contains('cancle') ? '' : discountCodeValue].join(','),
                discount: existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();

        if(data){
            this.button.disabled = false;
            this.button.classList.remove('loading');
        }

        if(data.discount_codes && data.discount_codes.length === 0) {
            this.showToast('success', 'You have cancelled the discount code');
            this.input.value = '';
            this.radios.forEach((radio) => { radio.checked = false;});
            this.button.classList.remove('selected');
           
        }else{

            const discount_codes = data.discount_codes.find((discount) => { return discount.code == discountCodeValue;});
            if (discount_codes && discount_codes.applicable) {
                this.showToast('success', `Success! You saved ${window.theme.formatMoney(data.total_discount)}.`);
                this.input.value = '';
                const discountCodeList = this.querySelector('.discount-code-list');
                if (discountCodeList && ![...discountCodeList.children].some(item => item.querySelector("span").textContent.trim() === discountCodeValue)) {
                    const codeItem = document.createElement('div');
                    codeItem.className = 'code-item';
                    codeItem.innerHTML = `<span>${discountCodeValue}</span><div class="discount-del" data-code="${discountCodeValue}"></div>` ;
                    discountCodeList.appendChild(codeItem);
                }
            } else {
                if(data.discount_codes.length > 1){
                    this.showToast('error', 'Discount codes cannot be combined.');
                }else{
                    this.showToast('error', 'Invalid code. Please try again.');
                }
            }
            this.input.value = '';
            this.radios.forEach((radio) => { radio.checked = false;});
            this.button.classList.remove('selected');
            // 删除不能用的code
            data.discount_codes.forEach((discount) => {
                if (!discount.applicable) {
                    const codeItem = this.querySelector(`.discount-del[data-code="${discount.code}"]`);
                    if (codeItem) {
                        codeItem.parentNode.remove();
                    }
                }
            });

        }
        // 更新购物车
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));


    }
}
if (!customElements.get('cart-discount-component')) {
    customElements.define('cart-discount-component', CartDiscount);
}

